var map = {
	"./api/clearCache.md": 34,
	"./api/defaults.md": 35,
	"./api/extend.md": 36,
	"./api/jpex.md": 37,
	"./api/plugins.md": 38,
	"./api/register.md": 39,
	"./api/resolve.md": 40,
	"./api/trigger.md": 41,
	"./api/use.md": 42,
	"./guide/dependencies.md": 43,
	"./guide/extend.md": 44,
	"./guide/factories.md": 45,
	"./guide/getting-started.md": 46,
	"./guide/intro.md": 47,
	"./guide/plugins.md": 48,
	"./plugins/jpex-defaults.md": 49,
	"./plugins/jpex-folder.md": 50,
	"./plugins/jpex-mocks.md": 51,
	"./plugins/jpex-node.md": 52,
	"./plugins/jpex-web.md": 53,
	"./plugins/plugins.md": 54
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;



//////////////////
// WEBPACK FOOTER
// ./src/content ^\.\/.*\.md$
// module id = 63
// module chunks = 0